import { render, staticRenderFns } from "./Component-MaterialStorage.vue?vue&type=template&id=a6a6d224&"
import script from "./Component-MaterialStorage.vue?vue&type=script&lang=js&"
export * from "./Component-MaterialStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports